import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { motion } from 'framer-motion';
import { posts } from '../data/posts';
import SEO from '../components/common/SEO';
import BlogCTA from '../components/blog/BlogCTA';

const BlogPost = () => {
  const { slug } = useParams();
  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="pt-32 pb-24 px-4 sm:px-6 lg:px-8 bg-white">
      <SEO 
        title={post.title} 
        description={post.excerpt} 
        canonical={`/blog/${post.slug}`} 
      />
      
      <div className="max-w-2xl mx-auto">
        <Link 
          to="/blog" 
          className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-zinc-950 transition-colors mb-12 inline-block"
        >
          &larr; Back to Journal
        </Link>

        <motion.article 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <header className="mb-8">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 block">
              {post.date}
            </span>
          </header>

          <div className="prose prose-zinc prose-lg max-w-none prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tight prose-a:text-zinc-950 prose-a:font-bold hover:prose-a:text-zinc-600">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {post.content}
            </ReactMarkdown>
          </div>

          <BlogCTA />
        </motion.article>
      </div>
    </div>
  );
};

export default BlogPost;